module.exports = __webpack_public_path__ + "static/patient_wheelchair_09-1970.ab568e70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project2/patient_wheelchair_09-1970.jpg
// module id = 499
// module chunks = 8418805283199